import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kt-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
})
export class ChipComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning' | 'neutral' =
    'neutral';
  @Input() content: string;
  @Input() iconContent: string;
  @Input() removable: boolean;
  @Output() removed = new EventEmitter();
}
